import { render, staticRenderFns } from "./DxpServiceProviderSelect.vue?vue&type=template&id=70144555"
import script from "./DxpServiceProviderSelect.vue?vue&type=script&lang=js"
export * from "./DxpServiceProviderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports